import { ArrowRight, Globe, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

const OFFICIAL_CHANNELS = [
  {
    href: "https://www.allugator.com/",
    label: "Site oficial Allu",
    icon: Globe,
  },
  {
    href: "https://www.instagram.com/allu.oficial/",
    label: "@allu.oficial",
    icon: Instagram,
  },
  {
    href: "https://allugatorinvest.com/",
    label: "Site Allu Invest",
    icon: Globe,
  },
  {
    href: "https://www.instagram.com/invistanaallu/",
    label: "@invistanaallu",
    icon: Instagram,
  },
];

const EventBadge = () => (
  <span className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 bg-[#1F4A33] text-[#D1F8E2] text-[11px] font-semibold tracking-[0.1em] uppercase ring-1 ring-[#4BD084]/40">
    <span className="inline-flex h-1.5 w-1.5 rounded-full bg-[#4BD084]" />
    Seleção de parceiros · Allu Invest
  </span>
);

const KpmgPill = () => (
  <span className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 bg-white text-[#112711] text-[11px] font-semibold tracking-[0.06em] uppercase ring-1 ring-white/20">
    <img
      src="/selecao/kpmg.svg"
      alt=""
      aria-hidden="true"
      className="h-3.5 w-auto"
      loading="lazy"
      decoding="async"
    />
    KPMG Emerging Giants 2026
  </span>
);

export const EventoHero = () => {
  return (
    <section className="relative bg-[#0B1A0B] overflow-hidden">
      {/* Background photo — sede em B&W, mais visível */}
      <div aria-hidden="true" className="absolute inset-0">
        <img
          src="/evento/hero-bg.jpg"
          alt=""
          className="w-full h-full object-cover"
          style={{ filter: "grayscale(100%) brightness(0.75) contrast(1.05)" }}
          fetchPriority="high"
          decoding="async"
        />
        {/* Overlay suave — preserva legibilidade sem matar a foto */}
        <div className="absolute inset-0 bg-[#0B1A0B]/55" />
        {/* Vinhete inferior pra ancorar conteúdo */}
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1A0B]/30 via-transparent to-[#0B1A0B]/75" />
      </div>

      <div className="relative container-wide pt-10 pb-12 sm:pt-16 sm:pb-16 md:pt-24 md:pb-20 lg:pt-28 lg:pb-24">
        <div className="max-w-3xl mx-auto text-center">
          {/* Badges */}
          <div className="flex flex-wrap items-center justify-center gap-2">
            <EventBadge />
            <KpmgPill />
          </div>

          {/* H1 */}
          <h1
            className="mt-6 sm:mt-8 text-[2.5rem] sm:text-5xl md:text-6xl lg:text-[4.5rem] font-medium text-white leading-[1.02]"
            style={{
              fontFamily:
                '"Playfair Display", Georgia, "Times New Roman", serif',
              letterSpacing: "-0.025em",
              textShadow: "0 2px 24px rgba(0,0,0,0.35)",
            }}
          >
            A Allu está selecionando parceiros para divulgar seus produtos
            de investimento.
          </h1>

          {/* Sub */}
          <p className="mt-6 sm:mt-7 text-base sm:text-lg md:text-xl text-zinc-200 max-w-2xl mx-auto leading-relaxed">
            Produtos de crédito securitizado com{" "}
            <strong className="font-semibold text-white">lastro real</strong> e
            10 anos de histórico. Agora, abrimos a divulgação para um grupo
            selecionado de sócios de casas de investimentos e assessores com
            carteira acima de R$ 50 milhões.
          </p>

          {/* Escassez — curadoria como filtro */}
          <div className="mt-10 sm:mt-12 flex items-center justify-center gap-3">
            <span aria-hidden="true" className="h-px w-8 sm:w-10 bg-white/15" />
            <span className="text-[10px] sm:text-[11px] font-semibold tracking-[0.22em] uppercase text-zinc-300">
              Aplicação revisada caso a caso · nem todos são aprovados
            </span>
            <span aria-hidden="true" className="h-px w-8 sm:w-10 bg-white/15" />
          </div>

          {/* CTA principal */}
          <div className="mt-8 sm:mt-10">
            <Link
              to="/evento/aplicar"
              className="inline-flex items-center justify-center gap-2 rounded-full font-semibold text-sm sm:text-base h-12 sm:h-[56px] px-7 sm:px-8 bg-[#4BD084] hover:bg-[#5fdc94] text-[#112711] shadow-xl shadow-black/30 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-[#0B1A0B] focus-visible:ring-[#4BD084]"
            >
              Quero me candidatar
              <ArrowRight className="w-4 h-4" />
            </Link>
            <p className="mt-3 text-xs text-zinc-300/80">
              Aplicação revisada manualmente · não há garantia de aprovação
            </p>
          </div>

          {/* Bullets — abaixo do CTA, sutis */}
          <ul className="mt-10 sm:mt-12 grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 max-w-2xl mx-auto text-left">
            <li className="flex items-start gap-2.5 text-sm text-zinc-200">
              <span
                aria-hidden="true"
                className="mt-2 block w-1 h-1 rounded-full bg-[#4BD084] shrink-0"
              />
              <span>
                <span className="font-semibold text-white">
                  Produto exclusivo
                </span>
                {" · "}divulgado só pela Allu até agora
              </span>
            </li>
            <li className="flex items-start gap-2.5 text-sm text-zinc-200">
              <span
                aria-hidden="true"
                className="mt-2 block w-1 h-1 rounded-full bg-[#4BD084] shrink-0"
              />
              <span>
                Para sócios de casa e assessores com carteira a partir de R$ 50
                milhões
              </span>
            </li>
          </ul>
        </div>

        {/* Canais oficiais — rodapé do hero */}
        <div className="mt-14 sm:mt-20 pt-5 sm:pt-6 border-t border-white/10 max-w-3xl mx-auto">
          <div className="text-[9px] font-semibold tracking-[0.14em] uppercase text-zinc-400 mb-2 text-center">
            Canais oficiais
          </div>
          <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-[11px] sm:text-xs">
            {OFFICIAL_CHANNELS.map((c) => (
              <li key={c.href}>
                <a
                  href={c.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 text-zinc-400 hover:text-white transition-colors"
                >
                  <c.icon className="w-3 h-3" aria-hidden="true" />
                  {c.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
